<dashboardnav>
    <cradua-rate-status
    [ratestatuss]="ratestatuss$ | async"
    (ratestatus)="onSubmitRateStatus($event)"
    (deleteRateStatusEvent)="onDeleteRateStatus($event)"
    *ngIf="(isLoadingRateStatus$ | async ) === false"
    >
  </cradua-rate-status>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingRateStatus$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
